'use strict';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';


export function parseCheckboxEvent(event) {
  const rawValue = event.target.value;
  if (isString(rawValue)) {
    return rawValue === 'true';
  } else {
    return rawValue === true;
  }
}

export function parseNumberEvent(event, def = null) {
  const rawValue = event.target.value;
  if (isString(rawValue)) {
    return rawValue === '' ? def : parseInt(rawValue, 10);
  } else {
    return null;
  }
}

export function parseFloatEvent(event, def = null) {
  const rawValue = event.target.value;
  if (isString(rawValue)) {
    return rawValue === '' ? def : parseFloat(rawValue.replace(/,/, '.'));
  } else {
    return null;
  }
}

export function applyNumericConstraint(nextValue, constraints) {
  if (constraints
    && isNumber(constraints.max)
    && nextValue > constraints.max
  ) {
    return constraints.max;
  } else if (constraints
    && isNumber(constraints.min)
    && nextValue < constraints.min
  ) {
    return constraints.min;
  } else {
    return nextValue;
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/react-form-utils/index.js